export default "__VITE_ASSET__DS4_gkXK__"